<template>
  <v-container>
    <v-card class="pa-16">
      <v-row>
        <v-col cols="12" md="12">
          <span class="text-h5">Department Activity Report</span>
        </v-col>
      </v-row>

      <v-row>
        <!-- <v-col cols="12" md="3">
          <v-autocomplete
            v-model="datasearch.emp_id"
            :items="emp_list"
            item-text="name"
            item-value="id"
            label="Employee Name"
            clearable
            @click:clear="
              $nextTick(() => {
                datasearch.emp_id = 0;
              })
            "
            outlined
            dense
            hide-details
          ></v-autocomplete>
        </v-col> -->
        <!-- <v-col cols="12" md="3">
          <v-autocomplete
            v-model="datasearch.customer_id"
            :items="customer_list"
            item-text="name"
            item-value="id"
            label="Client Name"
            clearable
            @click:clear="
              $nextTick(() => {
                datasearch.customer_id = 0;
              })
            "
            outlined
            dense
            hide-details
          ></v-autocomplete>
        </v-col> -->
        <v-col cols="12" md="3">
          <v-autocomplete clearable @click:clear="
            $nextTick(() => {
              datasearch.dep_id = 0;
            })
            "  v-model="datasearch.dep_id" :items="dep_list" label="Department"
            item-text="department_name" item-value="id" outlined dense hide-details></v-autocomplete>
        </v-col>
        <!-- @change="findChaege(datasearch.chargetype)" -->
        <v-col cols="12" md="3">
          <v-autocomplete v-model="datasearch.chargetype" :items="charge_list" label="Charge Type" item-text="name"
            item-value="value" clearable @click:clear="
              $nextTick(() => {
                datasearch.chargetype = '';
                showchargetype = '';
              })
              " outlined dense hide-details></v-autocomplete>
        </v-col>
        <!-- <v-col cols="12" md="3">
          <v-autocomplete
            v-model="datasearch.jobtitle_id"
            :items="jobtitle_list"
            item-text="name"
            item-value="id"
            label="Assignment"
            clearable
            @click:clear="
              $nextTick(() => {
                datasearch.jobtitle_id = '';
              })
            "
            outlined
            dense
            hide-details
          ></v-autocomplete>
        </v-col> -->

        <v-col cols="12" md="2">
          <v-menu v-model="menudatefrom" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computedDateFromFormatted" label="DateFrom" append-icon="mdi-calendar" readonly
                dense outlined v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="datasearch.datefrom" @input="menudatefrom = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="2">
          <v-menu v-model="menudateto" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computedDateToFormatted" label="DateTo" append-icon="mdi-calendar" readonly dense
                outlined v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="datasearch.dateto" @input="menudateto = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="2">
          <v-btn @click="searchdata()" color="#147eb1" dark block>
            <v-icon left>mdi-magnify</v-icon> Search</v-btn>
        </v-col>
      </v-row>

      <v-row style="margin-top: -20px;">
        <v-col cols="12" lg="12" md="12" style="margin-left:  auto; margin-right: auto;">
          <v-row class="d-flex justify-end">
            <v-col align="end" cols="12" lg="4" md="4" style="padding-left: 20px;padding-top: 20px;">
              <v-btn outlined class="btnexport" style="
                      width: 120px;
                    " @click="printpdf()">
                <v-icon left>mdi-printer</v-icon>print</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>


      <br />

      <v-card outlined tile>
        <v-data-table dense :search="search" :headers="headers" :items="desserts" class="elevation-1   595959">


        </v-data-table>
      </v-card>

      <PdfPreviewDialog v-model="dialogPDF" :blob="pdfBlob" :filename="getFileName()" />

      <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />
    </v-card>

  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import PdfPreviewDialog from "@/components/cards/PdfPreviewDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "../language/Advancelist.js";
import { tolocalestringnumber } from "../computing/tolocalestringnumber.js";
import unity from "@/unity/unity";
const moment = require('moment');

export default {
  name: "advance-list",
  data(vm) {
    return {
      pdfBlob:null,
      pdfObj:null,
      dialogPDF:false,
      depobject: null,
      disable_dep: false,
      menudatefrom: false,
      menudateto: false,
      datasearch: {
        emp_id: 0,
        customer_id: 0,
        jobtitle_id: 0,
        chargetype: "",
        dep_id: 0,
        // datefrom: "",
        // dateto: "",
        datefrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        // company_id: 13,
        company_id: localStorage.getItem(server.COMPANYID),
      },
      expanded: [],
      dataforprint: {
        title: "Dej-Udom & Associates Ltd.",
        subtitle: "Department Activity Report",
        sumary_overview: "Summary Overview",
        sumary_overview_details_number_of_employees: "Total Hours Logged: ",
        sumary_overview_details1: "Billable Hours (Time Based + Fixed Fee): ",
        sumary_overview_details2: "% Billable: ",
        sumary_overview_details3: "Non-Billable / Internal Hours: ",
        sumary_overview_details4: "Client Served: ",
        sumary_overview_details5: "Active Employees: ",
        details_left1: "Client Name: ",
        details_left2: "Position: ",
        details_left3: "Department: ",
        details_left4: "Period: ",
        details_left5: "Report Date: ",
        details_right1: "Total Leave Taken: ",
        details_right2: "Total Leave Quota: ",
        details_right3: "Total Adjacent to Holiday: ",
        details_right4: "Remark: ",
        title_graph: "",
        leave_summary: "Leave Summarry",
        leave_log_details: "Client Contribution",
        employee_contribution: "Employee Contribution",
        leave_log_details2: "Assignment Table",
      },
      months: [
        "Billable Hours", "Non-Billable / Internal Hours"
      ],
      desserts: [],
      desserts_details: [],
      dessertsclient: [],
      dessertsemployee: [],
      emp_id: 0,
      emp_list: [],
      jobtitle_list: [],
      customer_list: [],
      dep_list_search: [],
      emp_list_search: [],
      dep_id: 0,
      dep_list: [],
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      search_status: "",
      menu: false,
      menu2: false,
      search: "",
      toggleEnable: false,
      selectstatus: "",
      dataAll: [],
      status: ["Draft", "Request", "Approve", "Reject"],
      datefrom: null,
      dateto: null,
      dateCurrent: this.formatDateday(new Date().toISOString().substr(0, 10)),
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      defaultlanguage: "en",
      // regexlang: "th",
      chooselanguage: [
        { name: "en", flag: "gb" },
        { name: "th", flag: "th" },
      ],
      aa: "สวัสดี",
      dialogEdit: false,
      dialogDelete: false,
      mDataArray: [],
      position: [],
      approver: [],
      department: [],
      department_list: [],
      position_list: [],
      company: [],
      authorize: [],
      headers: [

        {
          text: "Metric",
          value: "metric",
          class: "bg-colorth tabletextwhite",
          width: "120px"
        },
        {
          text: "Value",
          value: "value",
          class: "bg-colorth tabletextwhite",
          width: "120px"
        },
      ],
      charge_list: [
        { value: "T/C", name: "Time Based" },
        { value: "N/C", name: "Non-Billable" },
        { value: "F/C", name: "Fixed Fee" },
        { value: "OFF", name: "Internal Office Work" },
      ],
      jobTitle_list: [],
      searchCharge: null,
      searchChargeJob: null,
      searchEmp: [],
      delete_id: 0,
      dialogDeleteActivity: false,
    };
  },

  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async created() {
    // this.initialize();
  },
  components: {
    SuccessDialog,
    PdfPreviewDialog,
  },
  beforeUpdate() { },
  computed: {
    computedDateFromFormatted() {
      return unity.formatDate(this.datasearch.datefrom);
    },
    computedDateToFormatted() {
      return unity.formatDate(this.datasearch.dateto);
    },
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },
  },
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.userId = localStorage.getItem(server.USER_ID);
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);


    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;
    // this.$router.back();

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    let comp_id = localStorage.getItem(server.COMPANYID);
    // await this.loadCompanyMaster(comp_id);
    // await this.loadDepartmentMaster(comp_id);
    // await this.loadPositionMaster(comp_id);

    await this.loadAuthorize();
    await this.setStartAndEndOfMonth();
    await this.loadEmpData();
    await this.loadDepData();
    await this.loadJobtitle();
    await this.loadCustomer();
    await this.loadCompany();
    await this.loadDepartmentByCompanyId(comp_id);
    await this.waitForPdfMake();


    this.$hideLoader();
  },
  methods: {
    async printpdf() {
      //  this.desserts = [];
      this.$showLoader();
      await this.previewPDF();
      this.$hideLoader();
      return;
      var dataitem = {
        company_id: Number(localStorage.getItem(server.COMPANYID)),
        datefrom: this.datefrom,
        dateto: this.dateto,
        emp_id: this.emp_id,
        dep_id: this.dep_id,
      }

      const result = await api.print_getAllCheckInOutEmployeeTimeattendancereport({
        params: dataitem
      });
      this.$hideLoader();

      if (result.data.length > 0) {
        this.desserts = result.data;
        this.$hideLoader();
        await this.previewPDF();
      } else {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Show data ",
          "Data not found ",
          "text-h5 red--text text-center"
        );
        return;
      }
      this.$hideLoader();

    },
       getFileName() {
  // const f = this.computedDateFromFormatted;
  // const t = this.computedDateToFormatted;
  const f = this.datasearch.datefrom;
  const t = this.datasearch.dateto;
  const dep = this.dep_list.find((x) => x.id === this.datasearch.dep_id);
  const name = dep ? dep.department_name.replace(/[\\/:*?"<>|]/g, "-").trim() : "";

  return name
    ? `Department_Activity_Report_${name}_${f}_${t}.pdf`
    : `Department_Activity_Report_${f}_${t}.pdf`;
},
 async previewPDF() {
    if (!this.pdfMakeReady) return alert("กรุณารอสักครู่ ระบบกำลังโหลด...");
    if (this.desserts.length < 1) {
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(true, "No Data", "Please search before printing.", "text-h5 red--text text-center");
      return;
    }

    this.$showLoader();
    try {
        const docDefinition = await this.generateDocDefinition(this.desserts);
      // pdfMake.createPdf(docDefinition).open();
        
      pdfMake.createPdf(docDefinition).getBlob((blob) => {
        this.pdfBlob = blob;
        this.dialogPDF = true;
        this.$hideLoader();
      });
    } catch (e) {
      this.$hideLoader();
      alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + e.message);
    }
  },
    async generateDocDefinition() {
      const mainStatement = await this.generateMainStatement();

      const docDefinition = {
        pageSize: "A4",
        pageMargins: [40, 20, 40, 20],
        content: mainStatement,
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };

      return docDefinition;
    },
    async generateMainStatement() {
      let mainContent = [];

      // ===== หน้าที่ 1: Employee Time Off Report =====
      // datajsonprint.forEach(async(x,i)=>{

      const chartData = await this.prepareChartData(this.dessertsclient);
      const chartDataemployee = await this.prepareChartDataEmployee(this.dessertsemployee);
      mainContent.push(
        // Header บริษัท + CONFIDENTIAL
        {
          columns: [
            {
              width: "*",
              stack: [
                {
                  text: "",
                  fontSize: 16,
                  bold: true,
                  margin: [0, 0, 0, 0],
                },
              ],
            },
            {
              width: 100,
              text: "CONFIDENTIAL",
              fontSize: 10,
              bold: true,
              color: "red",
              fillColor: "red",
              alignment: "center",
              margin: [0, 0, 0, 0],
            },
          ],
          margin: [0, 0, 0, 0],
        },
        {
          stack: [
            {
              text: this.dataforprint.title || "",
              fontSize: 16,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 0],
            },
            {
              text: this.dataforprint.subtitle || "",
              fontSize: 10,
              alignment: 'center',
              margin: [0, 0, 0, 0],
            },
          ],
          margin: [0, 0, 0, 0],
        },

        // ข้อมูลพนักงาน (Employee Information)
        {
          columns: [
            {
              width: "50%",
              stack: [
                {
                  text: [
                    { text: this.dataforprint.details_left1, fontSize: 9, bold: true },
                    { text: this.depobject ? this.depobject.department_name : "" || "", fontSize: 9 },
                  ],
                  margin: [0, 0, 0, 2],
                },
                {
                  text: [
                    { text: this.dataforprint.details_left4, fontSize: 9, bold: true },
                    { text: `${this.computedDateFromFormatted} - ${this.computedDateToFormatted}` || "", fontSize: 9 },
                  ],
                  margin: [0, 0, 0, 2],
                },
                {
                  text: [
                    { text: this.dataforprint.details_left5, fontSize: 9, bold: true },
                    {
                      text: this.dateCurrent || new Date().toLocaleDateString("en-GB"),
                      fontSize: 9,
                    },
                  ],
                },
              ],
            },
          ],
          margin: [0, 0, 0, 20],
        },



        {
          table: {
            widths: ["100%"],
            body: [
              [{
                stack: [
                  {
                    text: this.dataforprint.sumary_overview || "",
                    bold: true,
                    fontSize: 14,
                    alignment: 'left',
                    margin: [0, 0, 0, 0],
                  },
                ],
                margin: [10, 0, 10, 0],
              },
              ]
            ]
          },
          layout: "noBorders",
          fillColor: "#f5f5f5", // สีพื้นหลังต้องใส่นี่!
          margin: [0, 0, 0, 0]
        },
        //ข้อมูล summary overview

        {
          table: {
            widths: ["50%", "50%"],
            body: [
              [
                {
                  stack: [
                    {
                      text: [
                        { text: this.dataforprint.sumary_overview_details_number_of_employees, fontSize: 9, bold: true },
                      ],
                      margin: [10, 0, 10, 2],
                    },
                    {
                      text: [
                        { text: this.dataforprint.sumary_overview_details1, fontSize: 9, bold: true },
                      ],
                      margin: [10, 0, 10, 2],
                    },
                    {
                      text: [
                        { text: this.dataforprint.sumary_overview_details2, fontSize: 9, bold: true },
                      ],
                      margin: [10, 0, 10, 2],
                    },
                    {
                      text: [
                        { text: this.dataforprint.sumary_overview_details3, fontSize: 9, bold: true },
                      ],
                      margin: [10, 0, 10, 2],
                    },
                    {
                      text: [
                        { text: this.dataforprint.sumary_overview_details4, fontSize: 9, bold: true },
                      ],
                      margin: [10, 0, 10, 2],
                    },
                    {
                      text: [
                        { text: this.dataforprint.sumary_overview_details5, fontSize: 9, bold: true },
                      ],
                      margin: [10, 0, 10, 2],
                    },

                  ]
                },
                {
                  stack: [
                    // datajsonprint.map(d=>d.total_hours_logged_duration)
                    {
                      text: [
                        { text: this.desserts[3].value || "0 hrs", fontSize: 9 },
                      ],
                      alignment: "left",
                      margin: [10, 0, 10, 2],
                    },
                    {
                      text: [
                        { text: this.desserts[4].value || "0 hrs", fontSize: 9 },
                      ],
                      alignment: "left",
                      margin: [10, 0, 10, 2],
                    },
                    {
                      text: [
                        { text: this.desserts[5].value || "0 hrs", fontSize: 9 },
                      ],
                      alignment: "left",
                      margin: [10, 0, 10, 2],
                    },
                    {
                      text: [
                        { text: this.desserts[6].value || "0 hrs", fontSize: 9 },
                      ],
                      alignment: "left",
                      margin: [10, 0, 10, 2],
                    },
                    {
                      text: [
                        { text: this.desserts[7].value || "0 hrs", fontSize: 9 },
                      ],
                      alignment: "left",
                      margin: [10, 0, 10, 2],
                    },
                    {
                      text: [
                        { text: this.desserts[2].value || "0 hrs", fontSize: 9 },
                      ],
                      alignment: "left",
                      margin: [10, 0, 10, 2],
                    },

                  ]
                }
              ]
            ]
          },
          layout: "noBorders",
          fillColor: "#f5f5f5", // สีพื้นหลังต้องใส่นี่!
          margin: [0, 0, 0, 20]
        },
        // กราฟ Leaves Taken Days (Monthly) - Placeholder
        {
          stack: [
            {
              text: this.dataforprint.title_graph,
              fontSize: 12,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 0],
            }
          ],
          margin: [0, 0, 0, 0],
        },
        // {
        //   text: "Leaves Taken Days (Monthly)",
        //   fontSize: 12,
        //   bold: true,
        //   margin: [0, 0, 0, 10],
        // },
        {
          columns: [
            {
              width: 30,
              stack: this.generateYAxisLabels(chartData.values),
              margin: [0, 5, 0, 0]
            },
            {
              width: '*',
              stack: [
                {
                  canvas: this.generateBarChartCanvas(chartData.months, chartData.values),
                  margin: [0, 0, 0, 5]
                },
                {
                  columns: this.generateXAxisLabels(chartData.months, chartData.values),
                  margin: [0, 5, 0, 0]
                }
              ]
            }
          ],
          margin: [0, 0, 0, 10],
        },

        // Page Break
        // { text: "", pageBreak: "before" },

        // ===== หน้าที่ 2: Leave Log Details =====


        // ชื่อพนักงาน
        // {
        //   text: [
        //     { text: "Employee: ", fontSize: 10 },
        //     { text: this.header.employee_name || "", fontSize: 10, bold: true },
        //   ],
        //   margin: [0, 0, 0, 20],
        // },

        // Leave Log Details Title
        {
          text: this.dataforprint.leave_log_details,
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 10],
        },

        // Leave Log Details Table
        {
          table: {
            headerRows: 1,
            widths: [170, 70, 70, 170],
            body: [
              [
                {
                  text: "Client",
                  fontSize: 10,
                  bold: true,
                  fillColor: "#cccccc",
                  margin: [5, 5, 5, 5],
                },
                {
                  text: "Total Hours",
                  fontSize: 10,
                  bold: true,
                  fillColor: "#cccccc",
                  margin: [1, 5, 1, 5],
                },
                {
                  text: "Billable",
                  fontSize: 10,
                  bold: true,
                  fillColor: "#cccccc",
                  margin: [1, 5, 1, 5],
                },
                {
                  text: "Team members Involved",
                  fontSize: 10,
                  bold: true,
                  fillColor: "#cccccc",
                  margin: [1, 5, 1, 5],
                },
              ],
              ...this.dessertsclient.map((log) => [
                {
                  text: `${log.customer_name ? log.customer_name : "-"}` || "-",
                  fontSize: 8,
                  margin: [1, 1, 1, 1],
                },
                {
                  text: `${log.total_hours ? log.total_hours : "-"}` || "-",
                  fontSize: 8,
                  margin: [1, 1, 1, 1],
                },
                {
                  text: `${log.billable_hours ? log.billable_hours : "-"}` || "-",
                  fontSize: 8,
                  margin: [1, 1, 1, 1],
                },
                {
                  text: `${(log.emp_array) && (log.emp_array).length > 0 ? (log.emp_array).map(emp => emp.fullnameen || emp.fullnameth).join(", ") : "-"}` || "-",
                  fontSize: 8,
                  margin: [1, 1, 1, 1],
                },
              ]),
            ],
          },
          // layout: "lightHorizontalLines",
          layout: {
            hLineWidth: function (i, node) {
              // เส้นบนสุด (i == 0) และเส้นล่างสุด (i == node.table.body.length)
              // return (i === 0 || i === node.table.body.length) ? 1 : 0;
              return 1;
            },
            vLineWidth: function (i, node) {
              // เส้นซ้ายสุด (i == 0) และ ขวาสุด (i == node.table.widths.length)
              return (i === 0 || i === node.table.widths.length) ? 1 : 0;
            },
            // hLineWidth: function (i, node) {
            //   return 1;
            // },
            // vLineWidth: function (i, node) {
            //   return 1;
            // },
            hLineColor: function (i, node) {
              return '#000000';
            },
            vLineColor: function (i, node) {
              return '#000000';
            }
          },
          margin: [0, 0, 0, 20],
        },

        // Page Break
        { text: "", pageBreak: "before" },
        // { text: "", pageBreak: i == this.desserts.length -1?undefined:"before" },


        // Employee
        {
          columns: [
            {
              width: "*",
              stack: [
                {
                  text: "",
                  fontSize: 16,
                  bold: true,
                  margin: [0, 0, 0, 0],
                },
              ],
            },
            {
              width: 100,
              text: "CONFIDENTIAL",
              fontSize: 10,
              bold: true,
              color: "red",
              fillColor: "red",
              alignment: "center",
              margin: [0, 0, 0, 0],
            },
          ],
          margin: [0, 0, 0, 0],
        },
        {
          stack: [
            {
              text: this.dataforprint.title || "",
              fontSize: 16,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 0],
            },
            {
              text: this.dataforprint.subtitle || "",
              fontSize: 10,
              alignment: 'center',
              margin: [0, 0, 0, 0],
            },
          ],
          margin: [0, 0, 0, 0],
        },

        // ข้อมูลพนักงาน (Employee Information)
        {
          columns: [
            {
              width: "50%",
              stack: [
                {
                  text: [
                    { text: this.dataforprint.details_left1, fontSize: 9, bold: true },
                    { text: this.depobject ? this.depobject.department_name : "" || "", fontSize: 9 },
                  ],
                  margin: [0, 0, 0, 2],
                },
                {
                  text: [
                    { text: this.dataforprint.details_left4, fontSize: 9, bold: true },
                    { text: `${this.computedDateFromFormatted} - ${this.computedDateToFormatted}` || "", fontSize: 9 },
                  ],
                  margin: [0, 0, 0, 2],
                },
                {
                  text: [
                    { text: this.dataforprint.details_left5, fontSize: 9, bold: true },
                    {
                      text: this.dateCurrent || new Date().toLocaleDateString("en-GB"),
                      fontSize: 9,
                    },
                  ],
                },
              ],
            },
          ],
          margin: [0, 0, 0, 20],
        },

        // กราฟ Leaves Taken Days (Monthly) - Placeholder
        {
          stack: [
            {
              text: this.dataforprint.title_graph,
              fontSize: 12,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 0],
            }
          ],
          margin: [0, 0, 0, 0],
        },
        {
          stack: [
            {
              text: this.dataforprint.employee_contribution || "",
              fontSize: 12,
              bold: false,
              alignment: 'center',
              margin: [0, 0, 0, 0],
            }
          ],
          margin: [0, 0, 0, 10],
        },
        {
          columns: [
            {
              width: 30,
              stack: this.generateYAxisLabelsEmployee(chartDataemployee.values),
              margin: [0, 5, 0, 0]
            },
            {
              width: '*',
              stack: [
                {
                  canvas: this.generateBarChartCanvasEmployee(chartDataemployee.months, chartDataemployee.values),
                  margin: [0, 0, 0, 5]
                },
                {
                  columns: this.generateXAxisLabelsEmployee(chartDataemployee.months, chartDataemployee.values),
                  margin: [0, 5, 0, 0]
                }
              ]
            }
          ],
          margin: [0, 0, 0, 10],
        },

        // {
        //   text: this.dataforprint.employee_contribution,
        //   fontSize: 12,
        //   bold: true,
        //   margin: [0, 0, 0, 10],
        // },
        // Leave Log Details Table
        {
          table: {
            headerRows: 1,
            widths: [130, 70, 70, 130, 70],
            body: [
              [
                {
                  text: "Employee",
                  fontSize: 10,
                  bold: true,
                  fillColor: "#cccccc",
                  margin: [5, 5, 5, 5],
                },
                {
                  text: "Total Hours",
                  fontSize: 10,
                  bold: true,
                  fillColor: "#cccccc",
                  margin: [1, 5, 1, 5],
                },
                {
                  text: "Billable",
                  fontSize: 10,
                  bold: true,
                  fillColor: "#cccccc",
                  margin: [1, 5, 1, 5],
                },
                {
                  text: "Client Worked",
                  fontSize: 10,
                  bold: true,
                  fillColor: "#cccccc",
                  margin: [1, 5, 1, 5],
                },
                {
                  text: "% of Department Total",
                  fontSize: 10,
                  bold: true,
                  fillColor: "#cccccc",
                  margin: [1, 5, 1, 5],
                }
              ],
              ...this.dessertsemployee.map((log) => [
                {
                  text: `${log.fullnameen ? log.fullnameen : log.fullnameth}` || "-",
                  fontSize: 8,
                  margin: [1, 1, 1, 1],
                },
                {
                  text: `${log.total_hours ? log.total_hours : "-"}` || "-",
                  fontSize: 8,
                  margin: [1, 1, 1, 1],
                },
                {
                  text: `${log.billable_hours ? log.billable_hours : "-"}` || "-",
                  fontSize: 8,
                  margin: [1, 1, 1, 1],
                },
                {
                  text: `${(log.dpm_array) && (log.dpm_array).length > 0 ? (log.dpm_array).map(emp => emp.department_name).join(", ") : "-"}` || "-",
                  fontSize: 8,
                  margin: [1, 1, 1, 1],
                },
                {
                  text: `${((log.total_hours_number / this.dessertsemployee.reduce((sum, item) => sum + Number(item.total_hours_number), 0)) * 100).toFixed(2)} %` || "-",
                  fontSize: 8,
                  margin: [1, 1, 1, 1],
                },
              ]),
            ],
          },
          // layout: "lightHorizontalLines",
          layout: {
            hLineWidth: function (i, node) {
              // เส้นบนสุด (i == 0) และเส้นล่างสุด (i == node.table.body.length)
              // return (i === 0 || i === node.table.body.length) ? 1 : 0;
              return 1;
            },
            vLineWidth: function (i, node) {
              // เส้นซ้ายสุด (i == 0) และ ขวาสุด (i == node.table.widths.length)
              return (i === 0 || i === node.table.widths.length) ? 1 : 0;
            },
            // hLineWidth: function (i, node) {
            //   return 1;
            // },
            // vLineWidth: function (i, node) {
            //   return 1;
            // },
            hLineColor: function (i, node) {
              return '#000000';
            },
            vLineColor: function (i, node) {
              return '#000000';
            }
          },
          margin: [0, 0, 0, 20],
        },

      );
      // if(i == this.desserts.length -1 ){
      //  return mainContent;
      // }
      //  });
      return mainContent;

    },
    async prepareChartData(data) {
      const months = this.months;

      // สร้าง array สำหรับเก็บจำนวนวันลาของแต่ละเดือน
      const values = new Array(4).fill(0);


      values[0] = parseFloat(((data.reduce((sum, item) => sum + Number(item.billable_hours_number), 0) / data.reduce((sum, item) => sum + Number(item.total_hours_number), 0)) * 100)) || 0;
      values[1] = parseFloat(100 - ((data.reduce((sum, item) => sum + Number(item.billable_hours_number), 0) / data.reduce((sum, item) => sum + Number(item.total_hours_number), 0)) * 100)) || 0;
      return { months, values };
    },
    async prepareChartDataEmployee(data) {
      let months = [];

      // สร้าง array สำหรับเก็บจำนวนวันลาของแต่ละเดือน
      const values = new Array(data.length).fill(0);
      for (let i = 0; i < data.length; i++) {
        months[i] = data[i].fullnameen ? data[i].fullnameen : data[i].fullnameth;
        values[i] = ((data[i].total_hours_number / this.dessertsemployee.reduce((sum, item) => sum + Number(item.total_hours_number), 0)) * 100);

      }

      return { months, values };
    },
    async waitForPdfMake() {
      const checkInterval = setInterval(() => {
        if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
          this.pdfMakeReady = true;
          clearInterval(checkInterval);
          console.log("✅ pdfMake พร้อมใช้งาน พร้อมฟอนต์ภาษาไทย");
        }
      }, 100);

      setTimeout(() => {
        clearInterval(checkInterval);
        if (!this.pdfMakeReady) {
          console.error("❌ pdfMake โหลดไม่สำเร็จ");
          alert(
            "ไม่สามารถโหลดระบบ PDF ได้ กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ต"
          );
        }
      }, 10000);
    },
    async loadDepartmentByCompanyId(company_id) {
      let result = await api.getNewAllDepartment_By_CompanyID(company_id);
      this.department_list = result.data;

      var res_aut = await api.getSettingGroupMenu_ById(
        Number(localStorage.getItem(server.AUTHORIZE_ID))
      );
      if (res_aut.data.length > 0) {
        if (
          localStorage.getItem(server.ROLE) == "ADMIN" ||
          res_aut.data[0].sgm_name == "Director"
        ) {
          this.datasearch.dep_id = 0;
          this.disable_dep = false;
        } else {
          this.datasearch.dep_id = Number(
            localStorage.getItem(server.DEPARTMENT_ID)
          );
          this.disable_dep = true;
        }
      } else {
        if (localStorage.getItem(server.ROLE) == "ADMIN") {
          this.datasearch.dep_id = 0;
          this.disable_dep = false;
        } else {
          this.datasearch.dep_id = Number(
            localStorage.getItem(server.DEPARTMENT_ID)
          );
          this.disable_dep = true;
        }
      }
      // }
    },

    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async setStartAndEndOfMonth() {
      const today = new Date();

      // วันที่ 1 ของเดือนนี้
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      this.datasearch.datefrom = moment(startOfMonth).format("YYYY-MM-DD");;

      // วันที่สุดท้ายของเดือนนี้
      const endOfMonth = new Date();
      // const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.datasearch.dateto = moment(endOfMonth).format("YYYY-MM-DD");

      // await this.loaddata();
      // await this.searchdata();
    },
    async loadAuthorize() {
      const res_get = await api.getSettingGroupMenu();

      this.authorize = res_get.data;
    },

    async loaddata() {
      var dataitem = {
        company_id: Number(localStorage.getItem(server.COMPANYID)),
        datefrom: this.datefrom,
        dateto: this.dateto,
        emp_id: 0,
        dep_id: 0,
      }
      const resData = await api.getAllCheckInOutByDep({
        params: dataitem
      })
      this.dataAll = resData.data;
      this.mDataArray = resData.data;
      this.$hideLoader();
    },
    async loadEmpData() {
      const resultList = await api.getAccountsByCompanyCIO(Number(localStorage.getItem(server.COMPANYID)));
      this.emp_list = resultList.data;
      this.emp_list_search = resultList.data;
    },
    async loadDepData() {
      const resultDepList = await api.getNewAllDepartment_By_CompanyID(Number(localStorage.getItem(server.COMPANYID)));
      this.dep_list = resultDepList.data;
      this.dep_list_search = resultDepList.data;

    },
    async loadJobtitle() {
      const result = await api.getAllJobtitleByCompany(
        localStorage.getItem(server.COMPANYID)
      );

      this.jobtitle_list = result.data;
    },
    async loadCustomer() {
      const result = await api.getAllCustomerListactiveCompany({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
        },
      });
      this.customer_list = result.data;
    },
    async changeEmp() {
      if (this.emp_id != 0 && this.emp_id != null) {
        this.dep_id = 0;
        let aaa = this.emp_list_search.find(emp => emp.id === this.emp_id);
        this.dep_id = (this.dep_list_search.find(dpm => dpm.id === aaa.department_i_d)?.id) ?? 0;
      } else {
        this.emp_list = this.emp_list_search;
        this.dep_list = this.dep_list_search;
      }
    },
    async changeDep() {
      if (this.dep_id != 0 && this.dep_id != null) {
        this.emp_id = 0;
        this.emp_list = this.emp_list_search.filter(emp => emp.department_i_d === this.dep_id);
      } else {
        this.emp_list = this.emp_list_search
      }
    },
    async searchdata() {
      if (this.datasearch.dep_id == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Search Data",
          "Please Select Department",
          "text-h5 red--text text-center"
        );
        return;
      }
      this.desserts = [];
      this.dessertsclient = [];
      this.dessertsemployee = [];
      this.$showLoader();
      const resData = await api.print_getAllDepartmentActivityreport({
        params: this.datasearch,
      });
      // console.log(resData.data)
      if (resData.data.client_data.length > 0) {
        this.dessertsclient = resData.data.client_data;
        this.dessertsemployee = resData.data.employee_data;

        this.depobject = this.dep_list.find(i => Number(i.id) === Number(this.datasearch.dep_id))

        this.desserts = [{
          metric: "Period", value: `${this.computedDateFromFormatted} - ${this.computedDateToFormatted}`
        }, {
          metric: "Department", value: `${this.depobject ? this.depobject.department_name : ''}`
        }, {
          metric: "Active Employees", value: `${this.dessertsemployee.length}`
        }, {
          metric: "Total Hours Logged", value: `${this.dessertsclient.reduce((sum, item) => sum + Number(item.total_hours_number), 0).toFixed(2)} hrs`
        }, {
          metric: "Billable Hours (Time Based + Fixed Fee)", value: `${this.dessertsclient.reduce((sum, item) => sum + Number(item.billable_hours_number), 0).toFixed(2)} hrs`
        }, {
          metric: "% Billable", value: `${((this.dessertsclient.reduce((sum, item) => sum + Number(item.billable_hours_number), 0) / this.dessertsclient.reduce((sum, item) => sum + Number(item.total_hours_number), 0)) * 100).toFixed(2)} %`
        }, {
          metric: "Internal + Non-Billable Hours", value: `${(this.dessertsclient.reduce((sum, item) => sum + Number(item.total_hours_number), 0) - this.dessertsclient.reduce((sum, item) => sum + Number(item.billable_hours_number), 0)).toFixed(2)} hrs`
        }, {
          metric: "Active Employees", value: `${this.dessertsclient.length}`
        }
        ]

        this.$hideLoader();
      } else {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "ไม่มีข้อมูล",
          "text-h5 red--text text-center"
        );
        return;
      }

    },
    openPreviewMaps(data) {
      // ใช้ Regular Expression เพื่อดึงพิกัดจากข้อมูล
      const regex = /([\d.-]+)\s*,\s*([\d.-]+)/;
      const matches = data.match(regex);

      if (matches) {
        const lat = matches[1];  // ละติจูด (latitude)
        const lng = matches[2];  // ลองจิจูด (longitude)

        // สร้าง URL สำหรับเปิด Google Maps ที่จุดเดียว
        const url = `https://www.google.com/maps?q=${encodeURIComponent(lat)},${encodeURIComponent(lng)}`;
        window.open(url, '_blank');
      } else {
        console.error('ไม่พบพิกัดในข้อมูล');
      }
    },
    getRemarkWording(item) {
      if (item.total_day_sickleave >= 5 || item.total_percent_sickleave >= 50) {
        return "Monitor Sick Leave";
      } else if (item.total_useleave >= item.total_quota || item.total_percent > 100) {
        return "No Leave Taken";
      }
      else if (item.total_percent > 90) {
        return "Approaching Limit";
      }
      else if (item.total_percent >= 70 && item.total_percent <= 90) {
        return "Monitor Usage";
      }
      else if (item.total_percent < 70) {
        return "OK";
      } else {
        return "";
      }
    },
    getRemarkColor(item) {
      if (item.total_day_sickleave >= 5 || item.total_percent_sickleave >= 50) {
        return "orange";
      } else if (item.total_useleave >= item.total_quota || item.total_percent > 100) {
        return "red";
      }
      else if (item.total_percent > 90) {
        return "red";
      }
      else if (item.total_percent >= 70 && item.total_percent <= 90) {
        return "orange";
      }
      else if (item.total_percent < 70) {
        return "green";
      } else {
        return "black";
      }
    },
    parseLeaveDuration(leaveTime) {
      if (!leaveTime) return 0;

      let totalDays = 0;
      const hours = leaveTime;
      // const hours = parseInt(leaveTime);
      // totalDays += hours / 8; // แปลงชั่วโมงเป็นวัน (8 ชม. = 1 วัน)
      totalDays += hours;


      return totalDays;
    },
    getRandomInt() {
      let randoms = [];
      for (let index = 0; index < 12; index++) {
        randoms.push(Math.floor(Math.random() * (50000 - 5 + 1)) + 5);
      }
      return randoms;
    },
    generateYAxisLabels(values) {
      const maxValue = Math.max(...values, 10);
      const chartHeight = 150;
      const labels = [];

      for (let i = 10; i >= 0; i--) {
        const y = ((10 - i) * chartHeight) / 10;

        labels.push({
          text: `${Math.round((i * maxValue) / 10)} %`,
          fontSize: 8,
          alignment: 'left',
          absolutePosition: { x: 45, y: y + 247 }, // ปรับ x, y ตามตำแหน่งจริง
          margin: [0, 0, 0, 0]
        });
      }

      return labels;
    },
    generateYAxisLabelsEmployee(values) {
      const maxValue = Math.max(...values, 10);
      const chartHeight = 150;
      const labels = [];

      for (let i = 10; i >= 0; i--) {
        const y = ((10 - i) * chartHeight) / 10;

        labels.push({
          text: `${Math.round((i * maxValue) / 10)} %`,
          fontSize: 8,
          alignment: 'left',
          absolutePosition: { x: 45, y: y + 143 }, // ปรับ x, y ตามตำแหน่งจริง
          margin: [0, 0, 0, 0]
        });
      }

      return labels;
    },

    // ฟังก์ชันสร้าง X-axis labels
    generateXAxisLabels(months, values) {
      const chartWidth = 480;
      const spacing = chartWidth / months.length;

      return months.map((month, i) => ({
        // width: '*',
        width: spacing,
        text: `${month} ${values[i].toFixed(2)}%`,
        fontSize: 7,
        alignment: 'center'
      }));
    },

    generateXAxisLabelsEmployee(months, values) {
      // ${values[i].toFixed(2)}  %
      const chartWidth = 480;
      const spacing = chartWidth / months.length;

      return months.map((month, i) => ({
        width: spacing,
        text: `${month}`,
        fontSize: 7,
        alignment: 'center'
      }));
    },

    // ฟังก์ชันสร้าง canvas สำหรับแท่งกราฟและ grid เท่านั้น
    generateBarChartCanvas(months, values) {
      const maxValue = Math.max(...values, 10);
      const chartHeight = 150;
      const chartWidth = 480;
      const maxBarWidth = 70; // กำหนดความกว้างสูงสุดของแท่ง
      const calculatedBarWidth = (chartWidth / months.length) - 8;
      const barWidth = Math.min(calculatedBarWidth, maxBarWidth); // เลือกค่าที่น้อยกว่า
      const spacing = (chartWidth / months.length); // ระยะห่างระหว่างแท่ง (ใช้ค่าเดิม)
      const baseY = chartHeight;
      const colors = [
        "#66BB6A",
        "#A6A09B",
      ];

      let canvas = [];

      // วาด Grid Lines แนวนอน
      for (let i = 0; i <= 10; i++) {
        const y = (chartHeight / 10) * (10 - i);

        canvas.push({
          type: 'line',
          x1: 0,
          y1: y,
          x2: chartWidth,
          y2: y,
          lineWidth: 0.5,
          lineColor: '#e0e0e0'
        });
      }

      // วาดแท่งกราฟ
      months.forEach((month, i) => {
        const barHeight = (values[i] / maxValue) * chartHeight;
        const centerX = i * spacing + (spacing / 2); // หาจุดกึ่งกลางของตำแหน่ง
        const x = centerX - (barWidth / 2); // วางแท่งให้อยู่กึ่งกลาง
        const y = baseY - barHeight;

        canvas.push({
          type: 'rect',
          x: x,
          y: y,
          w: barWidth,
          h: barHeight,
          color: "#66BB6A"
        });
      });

      return canvas;
    },

    generateBarChartCanvasEmployee(months, values) {
      const maxValue = Math.max(...values, 10);
      const chartHeight = 150;
      const chartWidth = 480;
      const maxBarWidth = 70; // กำหนดความกว้างสูงสุดของแท่ง
      const calculatedBarWidth = (chartWidth / months.length) - 8;
      const barWidth = Math.min(calculatedBarWidth, maxBarWidth); // เลือกค่าที่น้อยกว่า
      const spacing = (chartWidth / months.length); // ระยะห่างระหว่างแท่ง (ใช้ค่าเดิม)
      const baseY = chartHeight;
      const colors = [
        "#66BB6A",
        "#A6A09B",
      ];

      let canvas = [];

      // วาด Grid Lines แนวนอน
      for (let i = 0; i <= 10; i++) {
        const y = (chartHeight / 10) * (10 - i);

        canvas.push({
          type: 'line',
          x1: 0,
          y1: y,
          x2: chartWidth,
          y2: y,
          lineWidth: 0.5,
          lineColor: '#e0e0e0'
        });
      }

      // วาดแท่งกราฟ
      months.forEach((month, i) => {
        const barHeight = (values[i] / maxValue) * chartHeight;
        const centerX = i * spacing + (spacing / 2); // หาจุดกึ่งกลางของตำแหน่ง
        const x = centerX - (barWidth / 2); // วางแท่งให้อยู่กึ่งกลาง
        const y = baseY - barHeight;

        canvas.push({
          type: 'rect',
          x: x,
          y: y,
          w: barWidth,
          h: barHeight,
          color: "#66BB6A"
        });
      });

      return canvas;
    },
    async loadCompany() {
      let copany_datat = await api.getCompanyByID(
        localStorage.getItem(server.COMPANYID)
      );
      this.dataforprint.title = copany_datat.data[0].name;
    },
    formatDatetomonthdayyear(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
    },
    formatDateday(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<style scoped>
.bg-colorth {
  background-color: #595959;
  color: red;
}

.text-left {
  color: aliceblue;
}

.widthsizesearch {
  width: 70%;
}

.theme--light.v-card {
  border-color: white;
}

.description-text {
  cursor: pointer !important;
  transition: color 0.3s ease !important;
  color: blue;
}

.description-text:hover {
  color: darkblue !important;
  /* สีที่เปลี่ยนเมื่อ hover */
}

.v-btn:not(.v-btn--round).v-size--default.btnexport {
  background-color: #ffffff;
  color: #33a4c0;
}
</style>
